import { styled } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';

export const drawerWidth = 100;

export const StyledDrawer = styled(Drawer)(({ theme }) => ({
	'& .MuiDrawer-paper': {
		borderRight: '1px solid rgba(255, 255, 255, 0.08)',
		height: '100vh',
		position: 'fixed',
		whiteSpace: 'nowrap',
		width: drawerWidth,
		paddingTop: '72px',
		overflow: 'hidden',
		background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.06) 0%, rgba(255, 255, 255, 0.02) 100%), #121212',
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
}));